/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  HTTPValidationError,
  SetOrganisationStandardAssembly200Item,
  SetStandardAssemblyDTO,
} from '../fastAPI.schemas'

/**
 * Make the given assembly the organisation's standard of its usage type,
replacing the previous standard. Returns the updated library.
 * @summary Set Organisation Standard Assembly
 */
export const setOrganisationStandardAssembly = (setStandardAssemblyDTO: SetStandardAssemblyDTO) => {
  return customInstance<SetOrganisationStandardAssembly200Item[]>({
    url: `/assemblies/standard-assembly`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: setStandardAssemblyDTO,
  })
}

export const useSetOrganisationStandardAssemblyMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOrganisationStandardAssembly>>,
    TError,
    { data: SetStandardAssemblyDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setOrganisationStandardAssembly>>,
  TError,
  { data: SetStandardAssemblyDTO },
  TContext
> => {
  const mutationKey = ['setOrganisationStandardAssembly']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setOrganisationStandardAssembly>>,
    { data: SetStandardAssemblyDTO }
  > = props => {
    const { data } = props ?? {}

    return setOrganisationStandardAssembly(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/assemblies/standard-assembly` },
    {
      operationId: 'set_organisation_standard_assembly_assemblies_standard_assembly_patch',
      operationName: 'setOrganisationStandardAssembly',
    },
  )

  return customOptions
}

export type SetOrganisationStandardAssemblyMutationResult = NonNullable<
  Awaited<ReturnType<typeof setOrganisationStandardAssembly>>
>
export type SetOrganisationStandardAssemblyMutationBody = SetStandardAssemblyDTO
export type SetOrganisationStandardAssemblyMutationError = HTTPValidationError

/**
 * @summary Set Organisation Standard Assembly
 */
export const useSetOrganisationStandardAssembly = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOrganisationStandardAssembly>>,
    TError,
    { data: SetStandardAssemblyDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setOrganisationStandardAssembly>>,
  TError,
  { data: SetStandardAssemblyDTO },
  TContext
> => {
  const mutationOptions = useSetOrganisationStandardAssemblyMutationOptions(options)

  return useMutation(mutationOptions)
}
